// source: pbtypes/gen/planner/image_space_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.planner.ImageSpaceSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.ImageSpaceSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.planner.ImageSpaceSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.ImageSpaceSettings.displayName = 'proto.planner.ImageSpaceSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.ImageSpaceSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.ImageSpaceSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.ImageSpaceSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.ImageSpaceSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
aggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
centeringAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
centeringLookAhead: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
deadZone: (f = msg.getDeadZone()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
discountingHalflife: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
lookatOnly: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
normalizedCoordinates: (f = msg.getNormalizedCoordinates()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.ImageSpaceSettings}
 */
proto.planner.ImageSpaceSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.ImageSpaceSettings;
  return proto.planner.ImageSpaceSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.ImageSpaceSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.ImageSpaceSettings}
 */
proto.planner.ImageSpaceSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAggressiveness(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCenteringAggressiveness(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCenteringLookAhead(value);
      break;
    case 4:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setDeadZone(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiscountingHalflife(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLookatOnly(value);
      break;
    case 7:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setNormalizedCoordinates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.ImageSpaceSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.ImageSpaceSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.ImageSpaceSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.ImageSpaceSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCenteringAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCenteringLookAhead();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDeadZone();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getDiscountingHalflife();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLookatOnly();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNormalizedCoordinates();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional double aggressiveness = 1;
 * @return {number}
 */
proto.planner.ImageSpaceSettings.prototype.getAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.setAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double centering_aggressiveness = 2;
 * @return {number}
 */
proto.planner.ImageSpaceSettings.prototype.getCenteringAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.setCenteringAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double centering_look_ahead = 3;
 * @return {number}
 */
proto.planner.ImageSpaceSettings.prototype.getCenteringLookAhead = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.setCenteringLookAhead = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional eigen_lcm.Vector2dPb dead_zone = 4;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.planner.ImageSpaceSettings.prototype.getDeadZone = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 4));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
*/
proto.planner.ImageSpaceSettings.prototype.setDeadZone = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.clearDeadZone = function() {
  return this.setDeadZone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.ImageSpaceSettings.prototype.hasDeadZone = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double discounting_halflife = 5;
 * @return {number}
 */
proto.planner.ImageSpaceSettings.prototype.getDiscountingHalflife = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.setDiscountingHalflife = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool lookat_only = 6;
 * @return {boolean}
 */
proto.planner.ImageSpaceSettings.prototype.getLookatOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.setLookatOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional eigen_lcm.Vector2dPb normalized_coordinates = 7;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.planner.ImageSpaceSettings.prototype.getNormalizedCoordinates = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 7));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.planner.ImageSpaceSettings} returns this
*/
proto.planner.ImageSpaceSettings.prototype.setNormalizedCoordinates = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.ImageSpaceSettings} returns this
 */
proto.planner.ImageSpaceSettings.prototype.clearNormalizedCoordinates = function() {
  return this.setNormalizedCoordinates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.ImageSpaceSettings.prototype.hasNormalizedCoordinates = function() {
  return jspb.Message.getField(this, 7) != null;
};


goog.object.extend(exports, proto.planner);
